import { Search } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

interface Props {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (v: string) => void;
}

/** Search box that reports trimmed input after a short pause (300 ms). */
export function SearchInput({ label, placeholder, value, onChange }: Props) {
  const [text, setText] = useState(value);
  const [synced, setSynced] = useState(value);
  // Adopt external changes (e.g. "Limpar filtros") without an effect.
  if (value !== synced) {
    setSynced(value);
    setText(value);
  }
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    if (text.trim() === value) return;
    const id = window.setTimeout(() => {
      onChangeRef.current(text.trim());
    }, 300);
    return () => {
      window.clearTimeout(id);
    };
  }, [text, value]);

  return (
    <div className="relative w-full max-w-xs">
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 left-2.5 size-3.5 -translate-y-1/2 text-fg-subtle"
      />
      <input
        type="search"
        aria-label={label}
        placeholder={placeholder ?? label}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
        }}
        className="h-8 w-full rounded-md border border-line-strong bg-canvas pr-2 pl-8 text-[13px] text-fg placeholder:text-fg-subtle hover:border-fg-subtle/60 focus:border-accent"
      />
    </div>
  );
}
